import React, { ChangeEvent, FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { FormGroup, Input, Label } from "reactstrap";
import Popover from "../../atoms/Popover";
import ErrorField from "./ErrorField";
import { toastUtils } from "../../../utils/toastUtils";
import { InputType } from "reactstrap/types/lib/Input";
import { FormikError, FormikTouchedType } from "../../../interfaces/ErrorInterfaces";

interface FormFileUploadProps {
  id?: string,
  className?: string,
  file?: File,
  fileName?: string,
  label?: string,
  required?: boolean,
  accept?: string[]
  error?: FormikError
  touched?: FormikTouchedType,
  type?: InputType,
  popover?: string,
  onChange?: (file: File) => void
  locked?: boolean
}

const FormFileUpload: FunctionComponent<FormFileUploadProps> = ({
  id,
  className = "",
  file,
  fileName,
  label,
  required,
  error,
  touched,
  type = "file",
  popover = "",
  accept = [".jpg", ".jpeg", ".pdf", ".docx", ".xlsx", ".xls", ".pptx", ".png"],
  onChange,
  locked = false
}) => {
  const intl = useIntl()

  const checkFileExtension = (file: File): boolean => {
    const fileNameParts = file.name.split(".")
    if (fileNameParts.length < 2) return false
    return accept.includes(`.${fileNameParts[fileNameParts.length - 1]}`)
  }

  const triggerOnChange = (file: File): void => {
    if (!checkFileExtension(file)) {
      toastUtils.errorToast(intl.formatMessage({ id: "upload_bad_file_type" }))
    } else {
      onChange(file);
    }
  }

  return (
    <FormGroup className={className}>
      <div className="d-flex flex-row epow-label">
        {label && (
          <Label htmlFor={locked ? undefined : id}>
            {intl.formatMessage({ id: label })}
            {required && <span aria-label="Champ obligatoire" className="required epow-danger ms-1 me-1">*</span>}
          </Label>
        )}
        {popover && (
          <div className="ms-2">
            <Popover text={popover} />
          </div>
        )}
      </div>
      {fileName && (
        <Input
          id={`${id}Name`}
          className="mb-2"
          value={fileName}
          disabled
        />
      )}
      <Input
        id={id}
        className={`${!!error ? "epow-input-error" : ""}${locked ? "d-none" : ""}`}
        type={type}
        file={file}
        accept={accept.join(", ")}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          triggerOnChange(e.target.files[0])
        }}
      />
      <ErrorField error={error} touched={touched} isFileInput/>
    </FormGroup>
  )
}

export default FormFileUpload
